import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { LinkButton } from './ProductsTabs.style';

// eslint-disable-next-line import/prefer-default-export
export const PromoteLinkButton = styled(LinkButton)`
  @media (max-width: 360px) {
    padding: 0 20px;
  }

  @media (${tabletMax}) and (min-width: 361px) {
    width: min(28vw, 210px);
  }
`;
